import SignIn from './SignIn.js';
import Landing from './Landing.js';
import PassportPage from './PassportPages.js';
import Activate from './Activate.js';
import Confirm from './Confirmation';

// Instantiate the General passport code
var $pageContainer = new PassportPage({
  container: '#body-wrapper'
});

// Instantiate the SignIn code if the element exists
var $signInContainer = new SignIn({
  container: '#signin.passport-page'
});

// Instantiate the Landing code if the element exists
var $landingContainer = new Landing({
  container: '#passport-landing.passport-page'
});

// Instantiate the activation code if the element exists
var $activationContainer = new Activate({
  container: '#login.passport-page'
});

var $confirmationContainer = new Confirm({
  container: '#confirm.passport-page'
});

export default {}